import { fetchGlobalParams, fetchStudentReduction } from '../queries/globalParams.queries';

import { useQuery } from '@tanstack/react-query';

export const useGlobalParams = () => {
    return useQuery({
        queryKey: ['globalParams'],
        queryFn: fetchGlobalParams,
    });
};

export const useStudentReduction = () => {
    return useQuery({
        queryKey: ['studentReduction'],
        queryFn: fetchStudentReduction,
    });
};
